import { render } from "./ModalCouponTransaction.vue?vue&type=template&id=eb1a1aec"
import script from "./ModalCouponTransaction.vue?vue&type=script&lang=js"
export * from "./ModalCouponTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__